"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CounterBackgroundType = exports.IconType = exports.CounterType = exports.CounterSize = exports.CounterColor = void 0;
var CounterColor;
(function (CounterColor) {
    CounterColor["BLUE"] = "blue";
    CounterColor["GREEN"] = "green";
    CounterColor["ORANGE"] = "orange";
    CounterColor["WHITE"] = "white";
    CounterColor["ALTERNATE"] = "alternate";
})(CounterColor = exports.CounterColor || (exports.CounterColor = {}));
var CounterSize;
(function (CounterSize) {
    CounterSize["SMALL"] = "small";
    CounterSize["MEDIUM"] = "medium";
    CounterSize["LARGE"] = "large";
})(CounterSize = exports.CounterSize || (exports.CounterSize = {}));
var CounterType;
(function (CounterType) {
    CounterType["GHOST"] = "ghost";
    CounterType["PRIMARY"] = "primary";
    CounterType["SQUARE"] = "square";
    CounterType["TEXT"] = "text";
})(CounterType = exports.CounterType || (exports.CounterType = {}));
var IconType;
(function (IconType) {
    IconType["ATTICONTV"] = "attIconTv";
})(IconType = exports.IconType || (exports.IconType = {}));
var CounterBackgroundType;
(function (CounterBackgroundType) {
    CounterBackgroundType["IMAGE"] = "image";
    CounterBackgroundType["ICON"] = "icon";
    CounterBackgroundType["TEXT"] = "text";
})(CounterBackgroundType = exports.CounterBackgroundType || (exports.CounterBackgroundType = {}));
//# sourceMappingURL=CounterProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Counter/CounterProps.js
// module id = 514
// module chunks = 8